import { render, staticRenderFns } from "./Plotly.vue?vue&type=template&id=1f3c9ce4&lang=pug&"
import script from "./Plotly.vue?vue&type=script&lang=js&"
export * from "./Plotly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports